import { useMemo } from 'react';

import { NameAndCreateDateFormatter } from '@/components/Grid/components/Table/formatters';
import column, { defaultColumn, defaultActionsColumn, deleteAction, editAction, defaultColumnId } from '@Components/Grid/utils/column';

import OrganizationLinkFormatter from './OrganizationLinkFormatter';
import ToggleFormatter from './ToggleFormatter';

export default function useColumns() {
  return useMemo(() => [
    defaultColumnId(),
    defaultColumn('name', 'Name', info => <NameAndCreateDateFormatter info={info} />),
    defaultColumn('domain', 'Domain', undefined, { enableTruncate: true }),
    column.accessor('organizationId', {
      header: 'Organization',
      cell: info => <OrganizationLinkFormatter info={info} />,
    }),
    defaultColumn('active', 'Active', info => <ToggleFormatter info={info} />, { initialSize: 'w-18', enableColumnResize: false, enableSorting: false }),
    defaultActionsColumn(editAction, deleteAction),
  ], [])
}
